import "slick-carousel";

/**
 * Initialize addon slider
 *
 * @return {Void}
 */

const $window = $(window);

$(".js-articles-slider").each(function () {
  const $this = $(this);

  $this.find(".articles").slick({
    dots: false,
    arrows: false,
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 3,
    autoplay: false,
    adaptiveHeight: false,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: "25px",
        },
      },
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ],
  });

  $this
    .find(".articles")
    .on("beforeChange", function (event, slick, currentSlide, nextSlide) {
      const $progressBarDesktop = $(".slider-progress-desktop");
      const $progressBarMobile = $(".slider-progress-mobile");
      if ($window.width() < 1024) {
        let calc = (nextSlide / (slick.slideCount - 1)) * 100 + 10;
        $progressBarMobile
          .css("background-size", calc + "% 100%")
          .attr("aria-valuenow", calc);
      } else {
        let calc = (nextSlide / (slick.slideCount - 1)) * 100 + 40;
        $progressBarDesktop
          .css("background-size", calc + "% 100%")
          .attr("aria-valuenow", calc);
      }
    });
});
